module.exports = __webpack_public_path__ + "img/79617600.fd2c630e.png";